import { render, staticRenderFns } from "./GDialog.vue?vue&type=template&id=ea273ed4&scoped=true&"
import script from "./GDialog.vue?vue&type=script&lang=ts&"
export * from "./GDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea273ed4",
  null
  
)

export default component.exports